
import { computed, defineComponent, toRefs } from 'vue';
import { useStore } from 'vuex';

import { overlayComposition } from '@/core/modules/overlay/services';

export default defineComponent({
	props: {
		datum: {
			type: Array,
			required: true,
		}
	},
	setup (props) {
		const { datum } = toRefs(props);
		const store = useStore();

		// Computed active frame
		const activeFrame = computed((): string => store.getters.get_activeFrame);

		// Computed Is Active
		const isActive = computed((): boolean => {
			const record: any = datum.value.find((_: any) => _.endpointId === activeFrame.value);
			return (record && record.target === 'true');
		});

		return { activeFrame, isActive, ...overlayComposition() }
	},
})
